//Confirmation Modal, combines all other confirmation modals
define(function (require) {
    const tpl = require('civicsViews/long_message_modal/t_lov_long_message_modal.hbs');

    return Marionette.LayoutView.extend({
        className:'confirmation-modal',
        template:tpl,
        events: {
            'click @ui.cancelButton':'cancelClicked',
            'click @ui.closeButton':'cancelClicked',
            'click @ui.submitButton':'submitClicked'
        },
        ui: {
            cancelButton:'.cancel-button',
            submitButton:'.submit-button',
            closeButton:'.bbm-btn-close'
        },
        initialize: function (options) {
            this.title = options.title;
            this.text = options.text;
        },
        onShow:function(){

        },
        onRender:function(){
            this.$el.rhythmThemeInit();
        },
        cancelClicked: function() {
            if(this.modalRegion) {
                this.modalRegion.hideModal();
            }
            else {
                this.destroy();
            }
        },
        templateHelpers:function(){
            return {
                closeButtonText: i18n.t('CIVICS.COMMON.CLOSE'),
                title: this.title,
                displayText: this.text
            }
        }
    });
});
